import React, { useContext } from "react";
import { Spin, TreeSelect } from "antd";
import {
    ChapterTree,
    getChapter,
    getChapterProp,
    getMaxFloor,
    getMax
} from "../../service/CourseDetail/chapter";
import { CourseContext } from "../../pages/CourseDetail/Store";
import useCurrentDate from "../../utils/useCurrentDate";
import useRequest from "../../utils/useRequest";
import { overFlow } from "../overFlow";

const { TreeNode } = TreeSelect;

interface Props {
    clickData?: ChapterTree[] | null;
    targetKey?: string;
    value?: string;
    onChange?: (select: string) => void;
}
const Index = ({ targetKey, clickData, ...restProps }: Props) => {
    const { course } = useContext(CourseContext);
    const { batchNo } = useCurrentDate();

    const nodeParams: getChapterProp = {
        dcCoursewareSourceParam: {
            delStatus: ""
        },
        dcCourseChapterEntity: {
            batchNo,
            delStatus: "",
            courseNo: course.courseNo,
            courseSeq: course.courseSeq
        }
    };
    const [treeData, { loading }] = useRequest(() => getChapter(nodeParams));

    function renderTreeNodes(data: ChapterTree[]) {
        const clickLevel = clickData ? getMaxFloor(clickData) : 0; //获取点击的node节点的层级

        return data.map(item => {
            if (!item.chapterName) {
                return null;
            }
            const disabled = {
                disabled: item.level + clickLevel >= getMax(targetKey)
            };
            if (item.children) {
                return (
                    <TreeNode
                        {...disabled}
                        title={
                            <div style={{ width: 300 }}>
                                {overFlow(item.chapterName)}
                            </div>
                        }
                        key={item.id.toString()}
                        value={item.id.toString()}
                        dataRef={item}>
                        {renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return (
                <TreeNode
                    {...disabled}
                    value={item.id.toString()}
                    key={item.id.toString()}
                    title={
                        <div style={{ width: 300 }}>
                            {overFlow(item.chapterName)}
                        </div>
                    }
                />
            );
        });
    }
    return (
        <Spin spinning={loading}>
            <TreeSelect
                treeDefaultExpandAll
                dropdownStyle={{
                    maxHeight: "40vh"
                }}
                {...restProps}
                style={{ width: "100%" }}>
                {renderTreeNodes(treeData || [])}
            </TreeSelect>
        </Spin>
    );
};

export default Index;
